/* WSS Deal Grid — countdown, copy-to-clipboard, drag-to-scroll carousels.
   Carousel base is CSS flex overflow-scroll; JS adds mouse/pen drag-to-scroll. */
(function () {
  'use strict';
  if (window.__dealGridInit) return;
  window.__dealGridInit = true;

  // ---- Copy to clipboard (hero code + coupon cards) ----
  // Legacy/non-secure-context fallback when navigator.clipboard is missing.
  function execCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) { /* copy unsupported */ }
  }

  // Optimistic feedback: flip the button to its "copied" state immediately, then
  // revert after a beat. Opt-in per button via [data-copied-label]/[data-copy-label]
  // on a child label; the .is-copied class drives the colour + pop animation in CSS.
  function flashCopied(btn) {
    btn.classList.add('is-copied');
    var labels = btn.querySelectorAll('[data-copied-label]');
    labels.forEach(function (el) {
      el.textContent = el.getAttribute('data-copied-label');
    });
    clearTimeout(btn.__copyTimer);
    btn.__copyTimer = setTimeout(function () {
      btn.classList.remove('is-copied');
      labels.forEach(function (el) {
        el.textContent = el.getAttribute('data-copy-label') || el.textContent;
      });
    }, 1600);
  }

  function initCopy() {
    document.querySelectorAll('.js-deal-copy').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        // Fire the visual feedback synchronously — never gate it on the clipboard
        // promise, which can hang in unfocused/preview/automation contexts.
        flashCopied(btn);
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).catch(function () { execCopy(code); });
        } else {
          execCopy(code);
        }
      });
    });
  }

  // ---- Countdown timer ----
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var deadline = new Date(el.getAttribute('data-deadline')).getTime();
      if (isNaN(deadline)) return;
      var d = el.querySelector('[data-cd="days"]'), h = el.querySelector('[data-cd="hours"]');
      var m = el.querySelector('[data-cd="min"]'), s = el.querySelector('[data-cd="sec"]');
      function tick() {
        var diff = deadline - Date.now();
        if (diff < 0) diff = 0;
        var sec = Math.floor(diff / 1000);
        if (d) d.textContent = pad(Math.floor(sec / 86400));
        if (h) h.textContent = pad(Math.floor((sec % 86400) / 3600));
        if (m) m.textContent = pad(Math.floor((sec % 3600) / 60));
        if (s) s.textContent = pad(sec % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  // ---- Drag-to-scroll carousels (mouse / pen; touch uses native scroll) ----
  function initCarouselDrag() {
    document.querySelectorAll('.deal-row__carousel-track').forEach(function (track) {
      var isDown = false, startX = 0, startScroll = 0, moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || e.pointerType === 'touch') return;
        isDown = true; moved = false;
        startX = e.clientX; startScroll = track.scrollLeft;
        // Don't capture the pointer or start dragging yet — a plain click that
        // captures the pointer gets its click event retargeted to the track,
        // so links/buttons inside a card never navigate. Defer both until the
        // pointer actually crosses the drag threshold (in pointermove).
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var walk = e.clientX - startX;
        if (!moved && Math.abs(walk) > 4) {
          moved = true;
          track.classList.add('is-dragging');
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) track.scrollLeft = startScroll - walk;
      });

      function end(e) {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);

      // Swallow the click that follows a real drag so cards/links don't activate
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      // Stop native image/link ghost-drag from hijacking the gesture
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  // ---- Headline single-line fit (shrink only headlines that would wrap) ----
  function fitHeadlines() {
    document.querySelectorAll('.deal-card__headline').forEach(function (el) {
      el.style.setProperty('--dc-fit', '1');           // reset before measuring
      var fit = 1, guard = 0;
      // nowrap + width:100% means overflow shows as scrollWidth > clientWidth
      while (el.scrollWidth > el.clientWidth + 1 && fit > 0.55 && guard < 20) {
        fit -= 0.04;
        el.style.setProperty('--dc-fit', fit.toFixed(2));
        guard++;
      }
    });
  }

  function init() { initCopy(); initCountdown(); initCarouselDrag(); fitHeadlines(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  // Re-fit once web fonts finish loading (metrics change) and on resize.
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fitHeadlines); }
  var __fitTimer;
  window.addEventListener('resize', function () {
    clearTimeout(__fitTimer);
    __fitTimer = setTimeout(fitHeadlines, 150);
  });
})();
